<template>
  <div>
    <v-toolbar dark color="primary" fixed>
      <v-toolbar-title
        class="toolbar-title font-bold white--text"
        :class="{ divider : !isMobile }">
        {{title}}
      </v-toolbar-title>
      <!--SCHEDULER NAVIGATION BUTTON-->
      <v-tooltip :disabled="!showTooltip" bottom>
        <v-btn
          class="toolbar-item"
          :class="{ active : isOnScheduler }"
          flat
          slot="activator"
          v-if="!isMobile && showSchedulerButton"
          @click="goToScheduler">
          Schedule
        </v-btn>
        <span>Go to Scheduler Dashboard</span>
      </v-tooltip>
      <!--SERVICE LOGS NAVIGATION BUTTON-->
      <v-tooltip :disabled="!showTooltip" bottom>
        <v-btn
          class="toolbar-item"
          :class="{ active : isOnServiceLogs }"
          flat
          slot="activator"
          v-if="!isMobile && showSLButton"
          @click="goToServiceLogs">
          Service Logs
        </v-btn>
        <span>Go to Service Log Dashboard</span>
      </v-tooltip>
      <!--SEARCH LOGS NAVIGATION BUTTON-->
      <v-tooltip :disabled="!showTooltip" bottom>
        <v-btn
          class="toolbar-item"
          :class="{ active : isOnSearchLogs }"
          flat
          slot="activator"
          v-if="!isMobile && showSLButton"
          @click="goToSearchServiceLogs">
          Search Logs
        </v-btn>
        <span>Go to Search Service Logs</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <span class="subheading font-weight-medium pr-2">
        {{fullName}}
      </span>
      <v-menu
        transition="slide-y-transition"
        open-on-hover
        offset-y>
        <!--vertical icon and activator for the menu-->
        <v-btn
          slot="activator"
          dark
          icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <!--menu items-->
        <v-list>
          <!--user preferences setting-->
          <v-list-tile @click="showDialog = true">
            <v-icon class="pr-3">settings</v-icon>
            User Preferences
          </v-list-tile>
          <!--SERVICE LOGS HELP-->
          <v-list-tile v-if="showSLButton" @click="openTab(serviceLogsHelpUrl)">
            <v-icon class="pr-3">help</v-icon>
            OT Service Logs Help
          </v-list-tile>
          <!--SCHEDULER HELP-->
          <v-list-tile v-if="showSchedulerButton" @click="openTab(schedulerHelpUrl)">
            <v-icon class="pr-3">help</v-icon>
            OT Scheduler Help
          </v-list-tile>
          <!--logout-->
          <v-list-tile @click="logout">
            <v-icon class="pr-3">exit_to_app</v-icon>
            Logout
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div v-if="showDialog">
      <user-preferences v-on:dialog:closed="showDialog = false"></user-preferences>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent */
  import { mapGetters } from 'vuex';
  import JWTHelper from '@/jwt-token';
  import UserPreferences from '@/components/user-preferences';

  export default {
    name: 'Toolbar',
    components: {
      UserPreferences
    },
    props: {
      title: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        showTooltip: 'showTooltip'
      }),
      isMobile() {
        return this.$mq === 'mobile';
      },
      isOnServiceLogs() {
        return this.title === 'OT Service Logs';
      },
      isOnScheduler() {
        return this.title === 'Scheduler';
      },
      isOnSearchLogs() {
        return this.title === 'Search Service Logs';
      }
    },
    data() {
      return {
        showSLButton: null,
        showSchedulerButton: null,
        fullName: '',
        showDialog: false,
        serviceLogsHelpUrl: `${process.env.HELP_URL}/ot-service-logs-faqs/`,
        schedulerHelpUrl: `${process.env.HELP_URL}/ot-scheduler-faqs/`
      };
    },
    created() {
      this.showSLButton = JWTHelper.hasServiceLogRights();
      this.showSchedulerButton = JWTHelper.hasSchedulerRights();
      this.fullName = JWTHelper.fullName();
    },
    methods: {
      logout() {
        localStorage.clear();
        // redirect to login page
        this.$router.push('/login');
      },
      goToServiceLogs() {
        this.$router.push('/dashboard');
      },
      goToSearchServiceLogs() {
        this.$router.push('/search');
      },
      goToScheduler() {
        this.$router.push('/scheduler');
      },
      openTab(url) {
        window.open(url, '_blank');
      }
    }
  };
</script>

<style lang="scss" scoped>
  #logout {
    font-weight: bold;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  .v-toolbar {
    .toolbar-title {
      font-family: 'Arvo', serif;
    }
    .divider {
      padding-right: 24px;
      border-right: 1px solid #fff;
    }
    .toolbar-item {
      /deep/ .v-btn__content {
        color: #91ADF5;
      }
      &.active {
        /deep/ .v-btn__content {
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toolbar.vue